// ui/components/VisitaDetalle.jsx  (presentacional: view model in; la tarjeta de imágenes llega como children)
import React from 'react';
import SectionCard from '../../../shared/ui/SectionCard.jsx';
import AsistenteCard from '../../../shared/ui/AsistenteCard.jsx';
import Campo from '../../../shared/ui/Campo.jsx';
import EmptyBox from '../../../shared/ui/EmptyBox.jsx';
import { formatFechaDetalle } from '../../../shared/domain/fecha';

const VisitaDetalle = ({ data, fotos = {}, children }) => {
  const productor = data.productor;

  return (
    <>
      <SectionCard title="Información general" subtitle="Datos registrados al crear la visita.">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '18px 24px' }}>
          <Campo label="Fecha" value={formatFechaDetalle(data.fecha)} />
          <Campo label="Motivo" value={data.motivo} />
          <Campo label="Registrado por" value={data.usuario_nombre} />
          <Campo label="Productor" value={data.productor_nombre} />
          <Campo label="Parcela" value={data.parcela_nombre} />
        </div>
        <div className="mt-3">
          <Campo label="Observaciones o recomendaciones" value={data.observaciones} />
        </div>
      </SectionCard>

      <SectionCard title="Productor visitado" subtitle="Ficha del productor que recibió la visita.">
        {productor ? (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 12 }}>
            <AsistenteCard asistente={productor} detalle={productor.localidad} fotoUrl={fotos[productor.uuid]} fullWidth />
          </div>
        ) : (
          <EmptyBox>Aún no hay productor registrado</EmptyBox>
        )}
      </SectionCard>

      {children}
    </>
  );
};

export default VisitaDetalle;
